// Appear: a small inline thing (a tag, a key, a list item) that fades and settles in when
// `show` turns on and fades out before it unmounts. Reveal's sibling for things that sit in a
// row, where a height track would be wrong. docs/operations/design-standard.md, "Motion".

import React, { useRef } from 'react';
import { MS, usePresence } from './motion';

export interface AppearProps {
  show: boolean;
  as?: 'span' | 'li' | 'div';
  className?: string;
  /** Nothing, for a mark that is only its own shape (a dot). */
  children?: React.ReactNode;
}

export const Appear: React.FC<AppearProps> = ({ show, as = 'span', className = '', children }) => {
  const { mounted, open } = usePresence(show, MS.exit);
  // What leaves is what was last shown, not whatever the hidden branch would render now.
  const last = useRef(children);
  if (show) last.current = children;
  if (!mounted) return null;
  const Tag = as;
  return (
    <Tag
      aria-hidden={show ? undefined : true}
      className={`${className} transition-[opacity,transform] motion-reduce:scale-100 motion-reduce:transition-[opacity] ${
        open ? 'scale-100 opacity-100 duration-standard ease-emphasized' : 'pointer-events-none scale-95 opacity-0 duration-exit ease-exit'
      }`}
    >
      {last.current}
    </Tag>
  );
};

export default Appear;
